import { Button, HStack, VisuallyHidden } from "@chakra-ui/react";
import { PropsWithChildren } from "react";
import {
  FaGamepad,
  FaHome,
  FaPatreon,
  FaQuestion,
  FaShoppingCart,
  FaTv,
  FaYoutube,
} from "react-icons/fa";
import { useMatch } from "react-router-dom";
import { ExternalLink, InternalLink } from "../link";

export const DesktopNav = () => {
  const isPartnerShipsActive = !!useMatch("/partnerships");
  const isHomeActive = !!useMatch("/");
  const isFAQActive = !!useMatch("/faq");
  const isHGWMActive = !!useMatch("/game-dev-docs");
  return (
    <nav>
      <HStack
        spacing={0}
        alignContent="center"
        border="1px solid"
        borderColor={"whiteAlpha.700"}
        borderBottomRadius={"lg"}
        display={["none", "none", "flex", "flex"]}
        backdropFilter="blur(3px)"
      >
        <SideNavInternalItem active={isHomeActive} icon={<FaHome />} href="/">
          Home
        </SideNavInternalItem>
        <SideNavInternalItem
          active={isPartnerShipsActive}
          icon={<FaGamepad />}
          href="/partnerships"
        >
          Partnerships
        </SideNavInternalItem>
        <SideNavInternalItem
          active={isHGWMActive}
          icon={<FaTv />}
          href="/game-dev-docs"
        >
          Game Dev Docs
        </SideNavInternalItem>
        <SideNavInternalItem
          active={isFAQActive}
          icon={<FaQuestion />}
          href="/faq"
        >
          FAQ
        </SideNavInternalItem>
        <SideNavInternalItem
          active={false}
          icon={<FaShoppingCart />}
          href="https://www.youtube.com/@ThatGuyGlen/store"
          newItem={true}
          external={true}
        >
          Store
        </SideNavInternalItem>
        <VisuallyHidden>
          <Button
            leftIcon={<FaPatreon />}
            as={ExternalLink}
            href="https://www.patreon.com/ThatGuyGlen"
          ></Button>

          <Button leftIcon={<FaYoutube />} as={ExternalLink}></Button>
        </VisuallyHidden>
      </HStack>
    </nav>
  );
};

type SideNavItemProps = PropsWithChildren<{
  icon: JSX.Element;
  href: string;
  active?: boolean;
  newItem?: boolean;
  external?: boolean;
}>;

const SideNavInternalItem = ({
  icon,
  children,
  href,
  active,
  newItem,
  external,
}: SideNavItemProps) => {
  return (
    <Button
      leftIcon={icon}
      variant="ghost"
      as={external ? ExternalLink : InternalLink}
      borderRadius={0}
      // @ts-ignore
      to={href}
      href={href}
      py={8}
      px={8}
      _hover={{ bgColor: "whiteAlpha.200" }}
      _active={{ bgColor: "whiteAlpha.200" }}
      isActive={active}
      _after={
        newItem
          ? {
              content: `" NEW"`,
              position: "absolute",
              top: "3px" /* Pulls it slightly above the button */,
              right: "3px" /* Pulls it slightly to the right */,
              backgroundColor: "var(--chakra-colors-cyan-200)",
              color: "var(--chakra-colors-gray-800)",
              fontSize: "9px",
              fontWeight: "bold",
              padding: "2px 5px",
              borderRadius: "4px",
              boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
            }
          : undefined
      }
    >
      {children}
    </Button>
  );
};
